export default "__VITE_ASSET__ItxwoUrT__"